<script>
import { mapState } from "vuex";

import countdownMixin from "@/mixins/countdownMixin";
import serverTimeMixin from "@/mixins/serverTimeMixin";

const MAX_TIME_TO_PAY = 1200;

export default {
  mixins: [countdownMixin, serverTimeMixin],

  methods: {
    onTimeout() {
      this.$router.push({
        name: "order",
        params: { order_id: this.payable.id }
      });
    }
  },

  computed: {
    ...mapState("payable", ["payable"])
  },

  async mounted() {
    await this.getServerTime();

    this.startCountDown(
      this.payable.created_at,
      MAX_TIME_TO_PAY,
      this.serverTime
    );
  }
};
</script>

<template>
  <div class="header">
    <div class="left">
    <img class="cart" src="/static/carrinho.svg" />

    <div class="header-text">FINALIZAR<br/> COMPRA</div>
    </div>

    <div class="right" v-if="serverTime">
      <span>TEMPO RESTANTE</span>

      <h1 v-if="time">{{ time }}</h1>

      <div class="progress-bar">
        <div class="progress-bar-total" />

        <div class="progress-bar-elapsed" :style="`width: ${percentageTimeLeft()}%`" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  border-bottom: solid 1px #e2e2e2;
  margin-bottom: 8px;
  padding-bottom: 8px;
}

.left {
  height: 100%;
  display: flex;
  align-items: flex-start;
}

.right {
  text-align: center;
}

.cart {
  height: 30px;
}

.header-text {
  margin-left: 8px;
  font-size: 20px;
  font-weight: 400;
  text-align: end;
}

br {
  display: block;
}

span {
  font-size: 10px;
}

h1 {
  margin: 0;
  font-weight: 500;
  font-size: 32px;
}

.progress-bar {
  width: 100%;
  height: 4px;
  position: relative;
}

.progress-bar-total,
.progress-bar-elapsed {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #af006b;
  border-radius: 2px;
}

.progress-bar-total {
  opacity: 0.25;
}

@media (min-width: 480px) {
  .left {
    height: fit-content;
    align-items: center;
  }

  br {
    display: none;
  }
}

@media (min-width: 580px) {
  .cart {
    height: 38px;
  }
  .header-text {
    font-size: 38px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Payable/OrderComponents/Header.vue